import React from 'react';
import { withStyles, withTheme} from '@material-ui/core/styles';
import Loading from '../../DisplayOriented/Loading';
import Company from "../../../services/DataModels/Company";
import FilterSidebar from '../../ActionOriented/FilterSidebar';
import AccountsList from '../../AccountSpecific/AccountsList';
import Card from '@material-ui/core/Card';

//contexts
import { SnackbarContext } from '../../../services/ContextProviders/Snackbar';

const styles = {
	container: {
		display: "flex",
		width: "100%",
	},
	filterBg: {
		position: "fixed",
		width: "100vw",
		height: "100vh",
		backgroundColor: "rgba(0,0,0,.5)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		top: 0,
		left: 0,
		zIndex: 9999
	},
	filterContainer: {
		position: "relative",
		zIndex: 3,
		width: "800px",
		backgroundColor: "white",
		padding: "72px 48px 35px 48px",
		overflowY: "auto",
		maxHeight: "750px",
	},
	link: {
		color: "#1153b6",
		"-webkit-text-decoration": "underline transparent",
		textDecoration: "underline transparent",
		transition: "text-decoration-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
		"&:hover": {
			"-webkit-text-decoration-color": "#1153b6",
			textDecorationColor: "#1153b6",
			cursor: "pointer",
		}
	}
};

class AccountsTab extends React.Component {

	constructor(props) {
		super(props);
		this.props = props;
		this.startingPerPage = 12;
		this.state = {
			show_filters: false,
			accounts: null,
			page_data: {
				page: 1,
				per_page: this.startingPerPage,
				page_meta: true,
				total: null
			}
		};
		this.load_accounts();
		this.set_filters();
		this.props.tabHostProxy.setRootRefresh(this.load_accounts);
	}

	set_filters = () => {
		this.filters = [
			{
				label: 'Name',
				type: 'text',
				field: 'name_like',
			},
			{
				label: 'Website',
				type: 'text',
				field: "website_like",
			},
			{
				label: 'Parent Account',
				type: 'lookup',
				placeholder: "Filter by parent account",
				field: "company_id",
				model: "companies",
				valueField: "_id",
				labelField: "name"
			}
		];
	}

	perform_sort = (sort_info) => {
		let sort = { order_by: ""};
		sort.order_by = sort_info.order === "desc" ? "-" + sort_info.order_by : sort_info.order_by;
		this.setState({sort: sort}, () => {
			this.load_accounts();
		});
	}

	load_accounts = () => {
		const {classes} = this.props;
		let params = Object.assign(this.state.page_data, this.state.filter_data, this.state.sort);
		delete params.total;
		if (this.state.accounts !== null) this.setState({accounts: null});
		new Company()
			.listFromAPI(params).then( (result) => {
				let accounts = result.items;
				Company.prepForList(accounts).then( (accounts) => {
					accounts.forEach( (account) => {
						if (!account.company_id || account.company_id === "" || !account.nested_company) {
							account.nested_company = { name: "No Parent Company"};
						}
						account.table_name = () => (<div onClick={() => this.props.tabHostProxy.addTab("account", account)} className={classes.link}>{account.name}</div>);
					});
					this.setState( (state) => {
						state.accounts = accounts;
						state.page_data = {
							page: params.page,
							per_page: params.per_page,
							page_meta: true,
							total: result.total
						};
						return state;
					});
				});
			}).catch( (error) => {
				this.context.openSnackbar(error, "error");
			});
	}

	page_change = (params) => {
		this.setState( (prev_state) => {
			return {
				page_data: {
					page: params.page,
					per_page: params.per_page,
					total: prev_state.page_data.total,
					page_meta: true
				}
			};
		}, () => {
			this.load_accounts();
		});
	}

	prepare_filter = (params) => {
		let body = {};
		if (params) {
			if (params["Name"]) {
				body.name_like = params["Name"];
			}
			if (params["Website"]) {
				body.website_like = params["Website"];
			}
			if (params["Parent Account"] && params["Parent Account"].values && params["Parent Account"].values.length > 0) {
				var companyIDs = params["Parent Account"].values.map((option) => {
					return option.value;
				});
				body.company_id_in = companyIDs.join(",");
			}
		}
		return body;
	}

	apply_filters = (filters) => {
		this.setState({filter_data: this.prepare_filter(filters)}, () => {
			this.load_accounts();
		});
	}

	is_filtering = () => {
		const filter_data = this.state.filter_data;
		if (filter_data == null || Object.entries(filter_data).length === 0) {
			return false
		} else {
			return true;
		}
	}

	render() {
		let { tabHostProxy, classes } = this.props;
		const { accounts, page_data } = this.state;
		return (
			<div className={classes.container}>
				<div style={{visibility: this.state.show_filters ? "visible" : "hidden"}} onClick={() => this.setState({show_filters: false})} className={classes.filterBg}>
					<Card
						onClick={(event) => event.stopPropagation()}
						className={classes.filterContainer}
					>
						<FilterSidebar
							filters={this.filters}
							triggerFilter={this.apply_filters}
							closeFilters={() => this.setState({show_filters: false})}
						/>
					</Card>
				</div>
				<AccountsList
					filtering={this.is_filtering()}
					show_filters={() => this.setState({show_filters: true})}
					page_change={this.page_change}
					accounts={accounts}
					perform_sort={this.perform_sort}
					page_data={page_data}
					tabHostProxy={tabHostProxy}
				/>
			</div>
		);
	}
}

AccountsTab.contextType = SnackbarContext;

export default withStyles(styles)(withTheme()(AccountsTab));
